module.exports = __webpack_public_path__ + "media/images/pen_violet-049652db.png";